import { render } from "./SignUp.vue?vue&type=template&id=53e119df"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HOSAM\\Desktop\\LIBYA\\qr-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__